import React from "react";
import UserList from "../components/users/UserList";

const Users: React.FC = () => {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900 mb-6">
        Gestione Utenti
      </h1>
      <UserList />
    </div>
  );
};

export default Users;
